import { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import EverythingSearch from 'components/EverythingSearch'
import { useBreakpoints } from 'utils/hooks'
import { IconSearch } from 'icons'
import { IS_BOOKING } from 'utils/constants'

const SearchIconWrapper = styled('div')(({ theme }) => ({
  height: 48,
  width: 48,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  'svg': {
    width: 18,
    height: 18,
  },
}))

const StyledBox = styled(Box)(({ theme }) => ({
  color: 'inherit',
  position: 'absolute',
  '& .MuiInputBase-input': {
    paddingLeft: '0 !important',
    boxSizing: 'border-box',
    transition: theme.transitions.create(['opacity']),
    opacity: 0,
  },
}))

const StyledSearchBox = styled(Box)(({ theme, smDown }) => ({
  display: 'inline-grid',
  overflow: 'hidden',
  gridAutoFlow: 'column',
  position: 'relative',
  borderRadius: '25px',
  border: `1px solid`,
  borderColor: smDown ? 'transparent' : theme.palette.border.neutral_500,
  transition: theme.transitions.create(['width', 'border-color']),
  height: 50,
  width: 50,
  cursor: 'pointer',
  '&:hover': {
    width: smDown ? 50 : 130,
    borderColor: theme.palette.border.neutral_500,
    '& input': {
      opacity: 1,
    },
  },
  '&:focus-within': {
    width: smDown ? 50 : 300,
    borderBottomLeftRadius: smDown ? undefined : 0,
    borderBottomRightRadius: smDown ? undefined : 0,
    borderColor: theme.palette.border.neutral_500,
    '& input': {
      opacity: 1,
    },
  },
}))

const Search = () => {
  const { smDown } = useBreakpoints()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!smDown) setOpen(false)
  }, [smDown])

  const handleClick = () => {
    if (!open) setOpen(true)
  }

  const handleClose = e => {
    if (open) {
      e.stopPropagation()
      e.preventDefault()
      setOpen(false)
    }
  }

  if (IS_BOOKING) return <div />

  return (
    <StyledSearchBox 
      smDown={smDown} 
      {...(smDown ? { 
        tabIndex: 0, 
        role: 'button', 
        onClick: handleClick,
      } : {})}
    >
      <SearchIconWrapper>
        <IconSearch 
          color="neutralCool_700"
          width="18"
          height="18"
        />
      </SearchIconWrapper>
      <StyledBox
        sx={{
          top: {
            xx: 0,
            sm: -1,
          },
          right: {
            xx: 0,
            sm: -1,
          },
          width: {
            xx: '100%',
            sm: 'calc(100% + 2px)',
          },
          height: {
            xx: '100%',
            sm: 'calc(100% + 2px)',
          },
        }}
      >
        <EverythingSearch
          variant="nav"
          open={open}
          onClose={handleClose}
        />
      </StyledBox>
    </StyledSearchBox>
  )
}

export default Search
